import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";

export const isTokenExpired = (token) => {
  if (!token || typeof token !== "string") return true;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;
    const base64Url = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64Url)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const payload = JSON.parse(jsonPayload);
    if (!payload.exp) return false;
    return payload.exp * 1000 <= Date.now();
  } catch (e) {
    return true;
  }
};

// Load token from localStorage if exists and unexpired
const rawToken = localStorage.getItem("adminToken");
let initialToken = null;
let initialAdminInfo = null;

if (rawToken && !isTokenExpired(rawToken)) {
  initialToken = rawToken;
  try {
    initialAdminInfo = JSON.parse(localStorage.getItem("adminInfo")) || null;
  } catch (e) {
    initialAdminInfo = null;
  }
} else if (rawToken) {
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminInfo");
}

// Async thunk for login
export const adminLogin = createAsyncThunk(
  "admin/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${config.backendUrl}/admin/signin`, { email, password });
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminInfo", JSON.stringify(response.data.admin));
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Login failed");
    }
  }
);

const initialState = {
  token: initialToken,
  adminInfo: initialAdminInfo,
  loading: false,
  error: null,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null;
      state.adminInfo = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminInfo");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.adminInfo = action.payload.admin;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = adminSlice.actions;
export default adminSlice.reducer;
